import { useLocalObservable } from 'mobx-react';
import { createFlightStores } from '../../../../../features/flights/shared/createFlightStores';
import { useCommonData } from '../../../../../common-data/useCommonData';

export function useCreateUnifiedSearchFlightStore() {
	const {
		flightsEnrichmentData: { airlines, airports },
	} = useCommonData();

	const flightStores = useLocalObservable(() => {
		const stores = createFlightStores();

		const { flightListStore, airlineStore, airportStore } = stores;
		flightListStore.setMinimumListLength(Infinity);
		flightListStore.initialLoad();

		airlineStore.setAirlines(airlines);
		airportStore.setAirports(airports);

		return stores;
	});

	return flightStores.flightListStore;
}
